import { render, staticRenderFns } from "./ClassRemindersSettings.vue?vue&type=template&id=86854682&scoped=true&"
import script from "./ClassRemindersSettings.vue?vue&type=script&lang=js&"
export * from "./ClassRemindersSettings.vue?vue&type=script&lang=js&"
import style0 from "./ClassRemindersSettings.vue?vue&type=style&index=0&id=86854682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86854682",
  null
  
)

export default component.exports